import { useQuery } from '@tanstack/react-query';

import { diseaseCodeApi } from '@/features/disease-code/api/disease-code.adapter';
import type { DiseaseCode, DiseaseGroup } from '@/features/disease-code/types/disease-code.types';

// Diagnosis pickers for the registration modal (FEATURE_014). Per admin prototype 02 환자관리:
//   주진단 (primary) = a disease GROUP  → sent as mainDiagnosisGroupId
//   부진단 (secondary) = a disease CODE within the selected group (도메인 종속 셀렉터) → sent as subDiagnosisCodeId
// Reuses the Disease Code Management API (PRD 08) — no new BE endpoint. Cached 5 min (changes infrequently).

const STALE_MS = 5 * 60 * 1000;

/** All disease groups for the primary-diagnosis (주진단) dropdown. */
export function useDiseaseGroupsQuery() {
  return useQuery({
    queryKey: ['patients', 'diagnosis-groups'] as const,
    queryFn: (): Promise<DiseaseGroup[]> => diseaseCodeApi.listGroups(),
    staleTime: STALE_MS,
  });
}

/** Active disease codes within the chosen group, for the secondary-diagnosis (부진단) dropdown (disabled until a group is picked). */
export function useDiseaseCodesQuery(groupId: number | null) {
  return useQuery({
    queryKey: ['patients', 'diagnosis-codes', groupId] as const,
    enabled: groupId != null,
    queryFn: async (): Promise<DiseaseCode[]> => {
      const codes = await diseaseCodeApi.listCodes(groupId as number);
      return codes.filter((c) => c.status === 'ACTIVE');
    },
    staleTime: STALE_MS,
  });
}
